import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGetProvidersUseCase } from '../../core/usecases/customConfiguration/GetProvidersUseCase';
import { IGetProvidersResponse } from '../../entity/interface/iGetProviders';
import { IGetFooterMenuResponse } from '../../entity/interface/iGetFooterMenu';
import { IGetFooterMenuContentUseCase } from '../../core/usecases/customConfiguration/GetFooterMenuContent';
import { IGetHeaderMenuResponse } from '../../entity/interface/IGetHeaderMenu';
import { IGetHeaderMenuContentUseCase } from '../../core/usecases/customConfiguration/GetHeaderMenuContent';
import { IBigScreenCmsGamesResponse, IBigScreenCmsMoodsResponse } from '../../entity/interface/iBigScreenCmsMoods';
import { IGetMoodsUseCase } from '../../core/usecases/customConfiguration/GetMoodsUseCase';
import { IGetGamesUseCase } from '../../core/usecases/customConfiguration/GetGamesUseCase';
import { IProfileAvatarsResponse } from '../../entity/interface/iProfile';
import { IProfileAvatarsUseCase } from '../../core/usecases/customConfiguration/GetProfileAvatarUseCase';

export interface ICustomConfigurationService {
    getProviders(dataSources: string): Promise<IGetProvidersResponse>;
    getFooterMenuContent(): Promise<IGetFooterMenuResponse>;
    getHeaderMenuContent(): Promise<IGetHeaderMenuResponse>;
    getMoods(): Promise<IBigScreenCmsMoodsResponse>;
    getGames(): Promise<IBigScreenCmsGamesResponse>;
    getProfileAvatars(): Promise<IProfileAvatarsResponse>;
}

export class CustomConfigurationService implements ICustomConfigurationService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getProvidersUseCase(): IGetProvidersUseCase {
        return container.resolve<IGetProvidersUseCase>(DI.USECASES.IGetProvidersUseCase);
    }

    private get getFooterMenuContentUseCase(): IGetFooterMenuContentUseCase {
        return container.resolve<IGetFooterMenuContentUseCase>(DI.USECASES.IGetFooterMenuContentUseCase);
    }

    private get getHeaderMenuContentUseCase(): IGetHeaderMenuContentUseCase {
        return container.resolve<IGetHeaderMenuContentUseCase>(DI.USECASES.IGetHeaderMenuContentUseCase);
    }

    private get getMoodsUseCase(): IGetMoodsUseCase {
        return container.resolve<IGetMoodsUseCase>(DI.USECASES.IGetMoodsUseCase);
    }

    private get getGamesUseCase(): IGetGamesUseCase {
        return container.resolve<IGetGamesUseCase>(DI.USECASES.IGetGamesUseCase);
    }

    private get getProfileAvatarsUseCase(): IProfileAvatarsUseCase {
        return container.resolve<IProfileAvatarsUseCase>(DI.USECASES.IGetProfileAvatarsUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getProviders(dataSources: string): Promise<IGetProvidersResponse> {
        return await this.getProvidersUseCase.execute(dataSources);
    }

    async getFooterMenuContent(): Promise<IGetFooterMenuResponse> {
        return await this.getFooterMenuContentUseCase.execute();
    }

    async getHeaderMenuContent(): Promise<IGetHeaderMenuResponse> {
        return await this.getHeaderMenuContentUseCase.execute();
    }

    async getMoods(): Promise<IBigScreenCmsMoodsResponse> {
        return await this.getMoodsUseCase.execute();
    }

    async getGames(): Promise<IBigScreenCmsGamesResponse> {
        return await this.getGamesUseCase.execute();
    }
    async getProfileAvatars(): Promise<IProfileAvatarsResponse> {
        return await this.getProfileAvatarsUseCase.execute();
    }
}
